export const ArrowLeft = ({ className }: { className?: string }) => {
  return (
    <svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M10.5385 0.602501C10.0498 0.112501 9.26188 0.112501 8.77318 0.602501L0.485282 8.9125C0.0963191 9.3025 0.096319 9.9325 0.485282 10.3225L8.77318 18.6325C9.26188 19.1225 10.0498 19.1225 10.5385 18.6325C11.0272 18.1425 11.0272 17.3525 10.5385 16.8625L3.31773 9.6125L10.5484 2.3625C11.0272 1.8825 11.0272 1.0825 10.5385 0.602501Z"
        fill="currentColor"
      />
    </svg>
  )
}
